import { render } from "./ObjectivesSection.vue?vue&type=template&id=00f02bc6&scoped=true"
const script = {}

import "./ObjectivesSection.vue?vue&type=style&index=0&id=00f02bc6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f02bc6"]])

export default __exports__